import { Button } from '@predoc/cow';
import { FileText, X } from 'lucide-react';
import type { PresignedUrlResponse } from '@/types/file-upload';

interface FileDisplayProps {
  file: File | PresignedUrlResponse;
  onRemove: () => void;
}

export const FileDisplay = ({ file, onRemove }: FileDisplayProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onRemove();
    }
  };

  const fileName = file instanceof File ? file.name : file.filename;

  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-transparent px-4 py-2">
      <div className="flex items-center gap-3">
        <FileText className="h-5 w-5 text-gray-500" />
        <span className="text-sm font-medium text-gray-900">{fileName}</span>
      </div>
      <Button
        variant="ghost"
        onClick={onRemove}
        onKeyDown={handleKeyDown}
        aria-label={`Remove ${fileName}`}
        tabIndex={0}
      >
        <X className="size-4" />
      </Button>
    </div>
  );
};
